module.exports = "<div class=\"container container-single\">\r\n  \r\n  <h2>Registration Confirmation</h2>\r\n  <div *ngIf=\"message\" class=\"message\">{{message}}</div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/registration/registration.confirmation.html
// module id = 310
// module chunks = 0